import { ChatPage } from "@/components/features/ai-chat/ChatPage";
import { useQuery } from "@tanstack/react-query";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/ai")({
  validateSearch: z.object({
    thread: z.string().uuid().optional().catch(undefined),
    matter: z.string().uuid().optional().catch(undefined),
  }),
  component: AiChatRoute,
});

function AiChatRoute() {
  const { thread, matter } = Route.useSearch();
  const navigate = Route.useNavigate();
  const matterQuery = useQuery(retrieveMatterQueryOptions(matter ?? ""));
  const matterData = matterQuery.data?.data;
  const matterTitle =
    matterData && !Array.isArray(matterData) ? matterData.title : undefined;
  return (
    <ChatPage
      initialThreadId={thread}
      matterId={matter}
      matterTitle={matterTitle}
      onSettingsNavigate={(page) => {
        void navigate({ to: page === "skills" ? "/skills" : "/automations" });
      }}
      onThreadChange={(threadId) => {
        void navigate({ search: { thread: threadId, matter } });
      }}
    />
  );
}
